import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ic-globe',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './ic-globe.html',
})
export class IcGlobeComponent {
  @Input() startColor: string | null = null;
  @Input() endColor: string | null = null;
  @Input() opacity = 1;
  @Input() width: number | string = 14;
  @Input() height: number | string = 14;

  defaultColor = '#B8C0C6';

  gradientId = `globeGradient-${Math.random().toString(36).slice(2)}`;

  get hasGradient(): boolean {
    return (
      typeof this.startColor === 'string' &&
      typeof this.endColor === 'string' &&
      this.startColor.trim() !== '' &&
      this.endColor.trim() !== ''
    );
  }
}
